var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarGreen20X20 = function SvgCalendarGreen20X20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.166 1.666c.46 0 .833.373.833.833v.834h.834a2.5 2.5 0 0 1 2.5 2.5v10a2.5 2.5 0 0 1-2.5 2.5H4.166a2.5 2.5 0 0 1-2.5-2.5v-10a2.5 2.5 0 0 1 2.5-2.5h.833v-.834a.833.833 0 0 1 1.667 0v.834h6.667v-.834c0-.46.373-.833.833-.833Zm2.5 8.333H3.333v5.834c0 .46.373.833.833.833h11.667c.46 0 .833-.373.833-.833V9.999ZM4.999 5h-.833a.833.833 0 0 0-.833.834v2.5h13.333v-2.5a.833.833 0 0 0-.833-.834h-.834v.834a.833.833 0 1 1-1.666 0v-.834H6.666v.834a.833.833 0 0 1-1.667 0v-.834Z",
    fill: "#008545"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.834 13.333c0-.458.375-.833.833-.833.459 0 .834.375.834.833a.836.836 0 0 1-.834.834.836.836 0 0 1-.833-.834Zm4.167-.833h3.333c.458 0 .833.375.833.833a.836.836 0 0 1-.833.834h-3.333a.836.836 0 0 1-.834-.834c0-.458.375-.833.834-.833Z",
    fill: "#008545"
  })));
};
export default SvgCalendarGreen20X20;